import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormInputPasswordComponent} from './form-input-password.component';
import {SharedModule} from '../../../modules/shared/shared.module';
import {PasswordModule} from 'primeng/password';
import {FormInputErrorModule} from '../form-input-error/form-input-error.module';

@NgModule({
  declarations: [
    FormInputPasswordComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PasswordModule,
    FormInputErrorModule
  ],
  exports: [
    FormInputPasswordComponent
  ]
})
export class FormInputPasswordModule {
}
